import api from '../../api/userIndicatorsRoutes.js';
 
const namespaced = true

const state = {
    userIndicators: [],
    userIndicatorsNot: [],
    loading:true
}

const mutations = {
    MUTATION_SET_USER_INDICATORS(state, data) {
        state.userIndicators = data.data;
        state.loading = false;
    },
    MUTATION_SET_USER_INDICATORS_NOT(state, data) {
        state.userIndicatorsNot = data.data;
    },
    MUTATION_ADD_USER_INDICADORES(state, value){
        // Remover del listado de no asignados usando el ID del DepartmentIndicator
        state.userIndicatorsNot = state.userIndicatorsNot.filter(
            ind => ind.id !== value.DepartmentIndicator.id
        );
        // Agregar al listado de asignados
        state.userIndicators.unshift(value);
    },
    MUTATION_DELETE_USER_INDICADORES(state, value){
        const deletedItem = state.userIndicators.find(ind => ind.id === value);
        
        if (deletedItem) {
            // Remover del listado de asignados usando el ID del DepartmentIndicator
            state.userIndicators = state.userIndicators.filter(ind => ind.id !== value);
            // Agregar al listado de no asignados
            state.userIndicatorsNot.push(deletedItem.DepartmentIndicator);
        }
    },
}


const actions = {
    getID(context, id) {
        return new Promise((resolve, reject) => {
            api.getID(id).then(function (res) {
                if (res.status === 200) {
                    context.commit('MUTATION_SET_USER_INDICATORS', res.data);
                    resolve(res.data);
                } else {
                    reject(new Error(res.data?.message || 'Error al obtener indicadores'));
                }
            }).catch((e) => {
                reject(e);
            })
        })
    },
    getIDNot(context, id) {
        return new Promise((resolve, reject) => {
            api.getIDNot(id).then(function (res) {
                if (res.status === 200) {
                    context.commit('MUTATION_SET_USER_INDICATORS_NOT', res.data);
                    resolve(res.data);
                } else {
                    reject(new Error(res.data?.message || 'Error al obtener indicadores'));
                }
            }).catch((e) => {
                reject(e);
            })
        })
    },
    store(context, data){
        return new Promise((resolve, reject) => {
            api.store(data).then(resp => {
                if (resp.status === 200) {
                    context.commit('MUTATION_ADD_USER_INDICADORES', resp.data);
                    resolve(resp.data);
                } else {
                    reject(new Error(resp.data?.message || 'Error al crear'));
                }
            }).catch((e) => {
                reject(e)
            })
        });
    },
    deleteUserIndi(context, id){
        return new Promise((resolve, reject) => {
            api.deleteUserIndi(id).then(resp => {
                if (resp.status === 200) {
                    context.commit('MUTATION_DELETE_USER_INDICADORES', id);
                    resolve(resp.data);
                } else {
                    reject(new Error(resp.data?.message || 'Error al eliminar'));
                }
            }).catch((e) => {
                reject(e)
            })
        });
    },     
}

const getters = {
    getIndi(state){
        return state.userIndicators;
    },
    getIndiNot(state){
        return state.userIndicatorsNot;
    },
    getloading(state){
        return state.loading;
    },
}

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
}

